import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { addOrganizationGroup } from '../../../../repository/OrganizationDAO';
import { useUserContext } from '../../../../context_providers/user_context/UserProvider';
import LoadingData from '../../../../components/loading/LoadingData';
import { useToast } from '../../../../context_providers/toast_context/ToastContext';
import BaseModal from '../../../../components/modals/BaseModal';
import { useTranslation } from 'react-i18next';
import {
  ErrorStringKeys,
  StringKeys,
  SuccessStringKeys,
} from '../../../../resources/strings/StringKeys';
import { urlSanitization } from '../../../../utils/app_support/InputSanitizaiton';
import { isReservedAllUsersGroupName } from '../allUsersConstants';

function CreateGroupModal({ onHide, show, orgCode, orgAzureId }) {
  const { bearerToken } = useUserContext();
  const [groupName, setGroupName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { showSuccessToast, showErrorToast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (show === false) {
      setGroupName('');
      setError('');
    }
  }, [show]);

  const handleAddGroupLocal = async () => {
    if (!groupName.trim()) {
      setError(t(StringKeys.GROUP_NAME_CANNOT_BE_EMPTY));
      return;
    }

    if (isReservedAllUsersGroupName(groupName)) {
      setError(t(StringKeys.GROUP_NAME_RESERVED_FOR_ALL_USERS_PAGE));
      return;
    }

    setLoading(true);
    setError('');
    try {
      await addOrganizationGroup(orgCode, groupName.trim(), orgAzureId);
      showSuccessToast(
        t(SuccessStringKeys.SUCCESSFULLY_ADDED_GROUP, {
          group: `${groupName}`,
        }),
      );
      onHide();
    } catch (error) {
      showErrorToast(
        t(ErrorStringKeys.FAILED_TO_ADD_GROUP, { group: `${groupName}` }),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setGroupName('');
    setError('');
    onHide();
  };

  return (
    <>
      <BaseModal
        open={show}
        onClose={handleModalClose}
        title={t(StringKeys.CREATE_A_GROUP)}
        onSubmit={handleAddGroupLocal}
        submitButtonText={t(StringKeys.ENTER)}
        size="sm"
        enableEnterKey={true}
      >
        <TextField
          fullWidth
          label={t(StringKeys.GROUP_NAME)}
          variant="outlined"
          value={groupName}
          onChange={(e) => setGroupName(urlSanitization(e))}
          error={!!error}
          helperText={error}
        />
      </BaseModal>
      <LoadingData show={loading} />
    </>
  );
}

export default CreateGroupModal;
